import React from 'react';
import { CreditCardIcon, FileTextIcon, GlobeIcon, LockIcon, ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { miniTestimonials } from '../data/content';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
const badges = [{
  icon: FileTextIcon,
  label: '100% Digital'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: GlobeIcon,
  label: 'Todos los países'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días sin preguntas'
}, {
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: CreditCardIcon,
  label: 'Pagás en la moneda de tu país'
}];
const stats = [{
  value: "+1.500",
  label: "personas confían en NATURIA"
}, {
  value: '6 tomos + 6 bonos',
  label: 'completamente listos'
}, {
  value: "4.7/5",
  label: 'calificación promedio'
}];
function Stars() {
  return <span className="flex items-center gap-0.5" aria-label="5 de 5 estrellas" data-id="element-103" data-mp="3czfkty10i55i">
      {[0, 1, 2, 3, 4].map(index => <StarIcon key={index} className="h-3.5 w-3.5 fill-mint-500 text-mint-500" aria-hidden="true" data-id="element-104" data-mp="384s78u7jqv5p" />)}
    </span>;
}
export function Hero() {
  return <header className="relative overflow-hidden bg-mint-50" data-id="element-105" data-mp="3o7vhbcfrj9tl">
      <div className="mx-auto max-w-6xl px-6 pb-16 pt-14 sm:pt-20" data-id="element-106" data-mp="39acyeqprnqu2">
        <div className="grid items-center gap-14 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] lg:gap-16" data-id="element-107" data-mp="39a36uyp2pbm9">
          <div data-id="element-108" data-mp="3ebiqcmblra2j">
            <Reveal data-id="element-109" data-mp="30i17l3qqq1dk">
              <p className="text-sm font-semibold uppercase tracking-[0.18em] text-mint-700" data-id="element-110" data-mp="30hho3ilfz4xf">
                Naturia · MegaPack Salud Plena
              </p>
              <h1 className="mt-5 font-display text-4xl leading-[1.05] text-ink sm:text-5xl lg:text-6xl" data-id="element-111" data-mp="35aue9x5rrjsa">
                Tu intestino inflamado,
                <span className="block text-mint-700" data-id="element-112" data-mp="2vi54r7ts4fzl">resuelto en 15 días.</span>
              </h1>
              <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-soft sm:text-xl" data-id="element-113" data-mp="2hix03zeukfo0">
                Transformá tu inflamación sin dietas restrictivas ni confusión sobre qué comer. Es simple y facil de implementar. No es necesario saber cocinar! 
              </p>
            </Reveal>

            <Reveal delay={0.06} data-id="element-114" data-mp="natatlbzb2pg">
              <ul className="mt-8 flex flex-wrap items-center gap-2.5" data-id="element-115" data-mp="n9qjjcaquy90">
                {badges.map(badge => <li key={badge.label} className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-white px-3.5 py-2 text-sm font-medium text-ink-soft ring-1 ring-inset ring-mint-200" data-id="element-116" data-mp="id00cg3n7mjd">
                    <badge.icon className="h-4 w-4 text-mint-600" aria-hidden="true" data-id="element-117" data-mp="1b0ds7zshhrwm" />
                    {badge.label}
                  </li>)}
              </ul>

              <div className="mt-8" data-id="element-118" data-mp="1126ncfbgz0az">
                <CtaButton data-id="element-119" data-mp="11152jj4nizg2">Quiero mi MegaPack ahora 70% OFF</CtaButton>
              </div>

              <ul className="mt-7 flex flex-wrap gap-x-6 gap-y-3" data-id="element-120" data-mp="x0crqlg4smho">
                {trust.map(item => <li key={item.label} className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-ink-muted" data-id="element-121" data-mp="3lu02z1erz4zq">
                    <item.icon className="h-4 w-4 text-mint-600" aria-hidden="true" data-id="element-122" data-mp="3hq24msx9xy7q" />
                    {item.label}
                  </li>)}
              </ul>
            </Reveal>
          </div>

          <Reveal delay={0.1} data-id="element-123" data-mp="21bfs9gsl6zq8">
            <img src="https://cdn.magicpatterns.com/uploads/4SbzwV6Qy75ioztca5TbYc/7722c05e-c1e3-4cb9-83af-899501559c43_(1).png" alt="Los 6 tomos del MegaPack Salud Plena en formato digital, vistos en libros y tablet" className="w-full rounded-3xl object-cover shadow-lift" width={1200} height={900} style={{
            objectFit: "none",
            width: "493px",
            height: "545px"
          }} data-id="element-124" data-mp="269zihte7qxoe" />
          </Reveal>
        </div>

        <Reveal delay={0.05} data-id="element-125" data-mp="2l0q76skidgna">
          <dl className="mt-16 grid gap-px overflow-hidden rounded-2xl bg-mint-200 sm:grid-cols-3" data-id="element-126" data-mp="2p08utw3ps5tt">
            {stats.map(stat => <div key={stat.value} className="bg-white px-6 py-6" data-id="element-127" data-mp="2tyadifx8a34r">
                <dt className="font-display text-2xl text-ink" data-id="element-128" data-mp="umzhtubym26t">{stat.value}</dt>
                <dd className="mt-1 text-sm text-ink-muted" data-id="element-129" data-mp="zlkjly6v0txd">{stat.label}</dd>
              </div>)}
          </dl>
        </Reveal>

        <Reveal delay={0.05} data-id="element-130" data-mp="4akzt6l1gyjo">
          <ul className="mt-10 grid gap-6 sm:grid-cols-3" data-id="element-131" data-mp="49t29q7vsqqr">
            {miniTestimonials.map(item => <li key={item.initials} className="flex h-full flex-col border-t border-mint-200 pt-5" data-id="element-132" data-mp="3vgvt2gjt4v0g">
                <Stars data-id="element-133" data-mp="e88y26huso6l" />
                <p className="mt-3 text-[15px] leading-relaxed text-ink" data-id="element-134" data-mp="e7h9vgql5sqc">
                  “{item.quote}”
                </p>
                <p className="mt-auto pt-4 text-sm text-ink-muted" data-id="element-135" data-mp="3hq0ubx30vual">
                  {item.name} · {item.location}
                </p>
              </li>)}
          </ul>
        </Reveal>
      </div>
    </header>;
}